<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            title="健康问卷"
            fixed
            left-arrow
            @click-left="$router.go(-1)"
        />

        <van-notice-bar style="margin-top: 44px;"
            wrapable
            :scrollable="false"
            text="为帮助您获得更准确的体检结果、体验更高效的体检过程，医生需要提前全面了解您的健康状况，特邀您抽出宝贵时间完善您的健康体检问卷。"
        />
        <div v-if="survey.updateDate" style="padding: 10px 16px; text-align: right;color: #A4A5A8; font-size: 12px;">健康问卷最近更新：{{survey.updateDate}}</div>
        <van-form>
            <van-cell-group title="基本信息">
                <van-field v-model="survey.name" placeholder="请填写" @blur="surveyAnswerChanged('name', survey.name)"
                >
                    <template #label>
                        <span class="my-required">* </span><span>姓名</span>
                    </template>
                </van-field>

                <van-field
                    readonly
                    clickable
                    :value="formatBirthday(survey.birthday)"
                    placeholder="点击选择生日"
                    :rules="[{ required: true, message: '请填写生日' }]"
                    @click="birthdayClicked"
                >
                    <template #label>
                        <span class="my-required">* </span><span>生日</span>
                    </template>
                </van-field>
                <van-popup v-model="showBirthdayPicker" position="bottom">
                    <van-datetime-picker
                        v-model="survey.birthday"
                        type="date"
                        title="选择生日"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @confirm="birthdaySelected"
                        @cancel="showBirthdayPicker=false"
                    />
                </van-popup>

                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.sex" direction="horizontal" @change="surveyAnswerChanged('sex', survey.sex)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['男','女']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>性别</span>
                    </template>
                </van-field>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.marriage" direction="horizontal" @change="surveyAnswerChanged('marriage', survey.marriage)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['已婚','未婚']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>婚姻状况</span>
                    </template>
                </van-field>

                <van-field v-model="survey.mobile" label="联系电话" placeholder="可填写" @blur="surveyAnswerChanged('mobile', survey.mobile)"/>
                <van-field v-model="survey.idCard" label="身份证号" placeholder="可填写" @blur="surveyAnswerChanged('idCard', survey.idCard)"/>

                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.occupation" direction="vertical" @change="surveyAnswerChanged('occupation', survey.occupation)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['国家公务员','专业技术人员','职员','企业管理人员','工人','农民','学生','现役军人','自由职业者','个体经营者','无业人员','退离休人员','其他']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>职业</span>
                    </template>
                </van-field>

<!--                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>对本次体检的心理预期是多少钱？</div>-->
<!--                <van-field name="radio">-->
<!--                    <template #input>-->
<!--                        <van-radio-group v-model="survey.expectedPrice" direction="vertical" @change="surveyAnswerChanged('expectedPrice', survey.expectedPrice)">-->
<!--                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['1000元以内','1000-2000元','2000-5000元','大于5000元']">{{ v }}</van-radio>-->
<!--                        </van-radio-group>-->
<!--                    </template>-->
<!--                    <template #label>-->
<!--                        <span class="my-required">* </span><span>答</span>-->
<!--                    </template>-->
<!--                </van-field>-->
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>目前是否处于备孕或怀孕状态？</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.forPregnant" direction="vertical" @change="surveyAnswerChanged('forPregnant', survey.forPregnant)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['是','否']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>

            </van-cell-group>

            <van-cell-group title="健康史">
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您的父母或兄弟姐妹是否患有明确诊断疾病？</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.familyHaveDisease" direction="horizontal" @change="surveyAnswerChanged('familyHaveDisease', survey.familyHaveDisease)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['是','否']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您是否患有明确诊断疾病或异常？</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.haveDisease" direction="horizontal" @change="surveyAnswerChanged('haveDisease', survey.haveDisease)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['是','否']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您是否曾出现过敏？</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.haveAllergy" direction="horizontal" @change="surveyAnswerChanged('haveAllergy', survey.haveAllergy)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['是','否']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您是否长期服用药物？（连续服用6个月以上，平均每日服用一次以上）</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.longtermMedication" direction="horizontal" @change="surveyAnswerChanged('longtermMedication', survey.longtermMedication)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['是','否']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您是否曾手术治疗？</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.haveSurgery" direction="horizontal" @change="surveyAnswerChanged('haveSurgery', survey.haveSurgery)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['是','否']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
                <div v-show="survey.sex === '女'" style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您是否曾绝经？</div>
                <van-field v-show="survey.sex === '女'" name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.femaleMenopause" direction="horizontal" @change="surveyAnswerChanged('femaleMenopause', survey.femaleMenopause)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['是','否']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
                <div v-show="survey.sex === '女'" style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您是否曾生育？</div>
                <van-field v-show="survey.sex === '女'" name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.femaleFertility" direction="horizontal" @change="surveyAnswerChanged('femaleFertility', survey.femaleFertility)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['是','否']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
            </van-cell-group>

            <van-cell-group title="躯体症状（最近3个月）">
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您感觉身体总体健康状况如何？</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.overallHealth" direction="horizontal" @change="surveyAnswerChanged('overallHealth', survey.overallHealth)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['好','一般','差']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;">您是否有以下症状？</div>
                <van-field name="radio" label="答">
                    <template #input>
                        <van-checkbox-group v-model="survey.haveSymptoms" direction="vertical" @change="surveyAnswerChanged('haveSymptoms', survey.haveSymptoms.join(','))">
                            <van-checkbox checked-color="var(--color)" :name="v" v-for="v in ['视力或听力有下降','鼻出血或脓血鼻涕','吞咽困难或哽噎感','明显咳嗽、咳痰','咯血或痰中带血','胸痛或心前区不适','胸闷或呼吸困难','低热（体温偏高）','头晕、头昏','食欲不振、消化不良、恶心、反酸或上腹部不适','腹痛、腹泻或大便习惯改变（大便次数、形状）','排尿困难、尿急、尿痛、尿血','大便带血或柏油样便','不明原因体重下降（较原体重下降超过10%）']">{{ v }}</van-checkbox>
                        </van-checkbox-group>
                    </template>
                </van-field>

                <van-field v-model="survey.otherSymptoms" label="其他不适" placeholder="请填写" @blur="surveyAnswerChanged('otherSymptoms', survey.otherSymptoms)"/>
            </van-cell-group>

            <van-cell-group title="生活习惯">
                <van-field name="radio" label="就餐习惯（可多选）">
                    <template #input>
                        <van-checkbox-group v-model="survey.eatingHabits" direction="vertical" @change="surveyAnswerChanged('eatingHabits', survey.eatingHabits.join(','))">
                            <van-checkbox checked-color="var(--color)" :name="v" v-for="v in ['清淡','偏咸','偏甜','辛辣','重油']">{{ v }}</van-checkbox>
                        </van-checkbox-group>
                    </template>
                </van-field>
                <van-field name="radio" label="饮食结构">
                    <template #input>
                        <van-radio-group v-model="survey.dietaryStructure" direction="vertical" @change="surveyAnswerChanged('dietaryStructure', survey.dietaryStructure)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['偏荤','偏素','荤素搭配']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;">您每天吃蔬菜水果共几种？</div>
                <van-field name="radio" label="答">
                    <template #input>
                        <van-radio-group v-model="survey.vegetableAmounts" direction="vertical" @change="surveyAnswerChanged('vegetableAmounts', survey.vegetableAmounts)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['1-2种','3-5种','多于5种']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;">您是否吸烟（持续吸烟1年以上）？</div>
                <van-field name="radio" label="答">
                    <template #input>
                        <van-radio-group v-model="survey.smokingHistory" direction="vertical" @change="surveyAnswerChanged('smokingHistory', survey.smokingHistory)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['不吸','吸烟','偶尔','曾吸烟，已戒']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;">您是否喝酒（平均每周饮酒1次以上）？</div>
                <van-field name="radio" label="答">
                    <template #input>
                        <van-radio-group v-model="survey.drinkingHistory" direction="vertical" @change="surveyAnswerChanged('drinkingHistory', survey.drinkingHistory)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['不喝','喝','偶尔','曾喝酒，已戒']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;">您每周参加几次体育锻炼？</div>
                <van-field name="radio" label="答">
                    <template #input>
                        <van-radio-group v-model="survey.exercisePerWeek" direction="vertical" @change="surveyAnswerChanged('exercisePerWeek', survey.exercisePerWeek)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['很少运动','每周1-2次','每周3-4次','每周5次以上']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;">您每次运动时间？</div>
                <van-field name="radio" label="答">
                    <template #input>
                        <van-radio-group v-model="survey.exerciseDuration" direction="vertical" @change="surveyAnswerChanged('exerciseDuration', survey.exerciseDuration)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['半小时内','半小时到1小时','1小时以上']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
            </van-cell-group>
            <van-cell-group title="睡眠健康">
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>最近一个月，您的睡眠如何？</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.sleepLastMonth" direction="horizontal" @change="surveyAnswerChanged('sleepLastMonth', survey.sleepLastMonth)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['好','一般','差']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
                <div style="padding: 10px 16px 0 16px;"><span class="my-required">* </span>您每天平均睡眠时间（不等于卧床时间）？</div>
                <van-field name="radio">
                    <template #input>
                        <van-radio-group v-model="survey.sleepPerDay" direction="vertical" @change="surveyAnswerChanged('sleepPerDay', survey.sleepPerDay)">
                            <van-radio checked-color="var(--color)" :name="v" v-for="v in ['少于5小时','5-7小时','7-9小时','9小时以上']">{{ v }}</van-radio>
                        </van-radio-group>
                    </template>
                    <template #label>
                        <span class="my-required">* </span><span>答</span>
                    </template>
                </van-field>
            </van-cell-group>

            <div style="padding: 16px;">
                <van-button :loading="loading" round block color="var(--color)" @click="saveClicked">提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import moment from "moment";
import qs from "qs";
import http from "@/utils/http";
import {Notify, Toast, Dialog} from "vant";

export default {
    name: "Survey",
    data() {
        return {
            loading: false,
            showBirthdayPicker: false,
            minDate: moment().subtract(100, 'years').toDate(),
            maxDate: new Date(),
            survey: {},
            code: ''
        };
    },
    components: {
    },
    mounted() {
        if(this.$route.path === '/s') {
            var code = this.$route.query.c ? this.$route.query.c : '';
            if(!code){
                this.$router.push('/');
                return;
            }
            this.survey.code = code;
        } else {//说明是登录的人要load
            this.loadDetail();
        }
    },
    methods: {
        birthdaySelected(date) {
            this.showBirthdayPicker = false;
            this.survey.birthday = date;
            this.surveyAnswerChanged('birthday', this.survey.birthday?moment(this.survey.birthday).format('YYYY-MM-DD'):'');
        },
        formatBirthday(date) {
            if(!date) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD");
        },
        birthdayClicked() {
            if(!this.survey.birthday) {
                this.survey.birthday = moment().subtract(30, 'years').toDate();
            }
            this.showBirthdayPicker = true;
        },
        saveClicked() {
            let payload = JSON.parse(JSON.stringify(this.survey));
            if(payload.birthday) {
                payload.birthday = moment(payload.birthday).format("YYYY-MM-DD");
            }
            if(payload.haveSymptoms) {
                payload.haveSymptoms = payload.haveSymptoms.join(",");
            }
            if(payload.eatingHabits) {
                payload.eatingHabits = payload.eatingHabits.join(",");
            }
            var url = '/api/personal/save_survey';
            if(payload.code){
                url = '/api/public/save_appointment_survey';
            }
            // console.log(payload)
            this.loading = true;
            http.post(url, qs.stringify(payload)).then(res => {
                this.loading = false;
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    Dialog.alert({
                        confirmButtonColor: '#b28303',
                        message: res.data.message,
                    }).then(() => {
                        this.$router.go(-1);
                    });
                }
            }).catch(() => this.loading = false);
        },
        surveyAnswerChanged(column, value) {
            if(!this.survey.code){
                return;
            }
            let payload = {code: this.survey.code, column: column, value: value}
            console.log('surveyAnswerChanged: ', payload);
            http.post('/api/public/save_appointment_survey_part', qs.stringify(payload));
        },
        loadDetail() {
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            http.get('/api/personal/load_survey').then(res => {
                Toast.clear();
                // console.log(res)
                var s = res.data.extra.survey;
                if(s){
                    s.haveSymptoms = s.haveSymptoms?s.haveSymptoms.split(','):[];
                    s.eatingHabits = s.eatingHabits?s.eatingHabits.split(','):[];
                    this.survey = s;
                }
            });
        }
    },
}
</script>

<style scoped>
.van-radio--vertical{
    margin-top: 10px;
}
.van-checkbox--vertical{
    margin-top: 10px;
}
.van-cell-group__title {
    background: #F6F6FB;
}
.my-required {
    color: #FF0000;
}
</style>